export default __webpack_public_path__ + "static/media/2FVISUAL_Background.d9d57765.jpg";